<sw-drawer [visible]="visible" (visibleChange)="onVisibleChange($event)" title="User Manual"
  width="min(82rem, 100vw)" [scrollBody]="false" [flushBody]="true" appendTo="body">
<div drawer-body class="sw-manual">

  <aside class="sw-manual-rail" [class.is-open]="railOpen">
    <div class="sw-manual-rail-head">
      <span class="sw-manual-eyebrow sw-text-2xs sw-tracking-widest">HOW TO USE</span>
      <h1 class="sw-manual-rail-title">SightWatch</h1>
    </div>

    <nav class="sw-manual-nav">
      @for (group of groups; track group.id) {
        <div class="sw-manual-nav-group">
          <span class="sw-manual-nav-group-title sw-text-2xs sw-tracking-wider">{{ group.title }}</span>
          @for (topic of group.topics; track topic.id) {
            <button
              type="button"
              class="sw-manual-nav-item"
              [class.is-active]="topic.id === activeTopic.id"
              [class.has-children]="topic.children?.length"
              [class.is-open]="isExpanded(topic)"
              (click)="selectTopic(topic)">
              @if (topic.children?.length) {
                <span class="sw-manual-nav-caret" role="presentation" (click)="toggleBranch(topic, $event)">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </span>
              }
              <span class="sw-manual-nav-icon" aria-hidden="true">
                @switch (topic.icon) {
                  @case ('calendar') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="3" y="4" width="18" height="18" rx="2"></rect><path d="M16 2v4M8 2v4M3 10h18"></path>
                    </svg>
                  }
                  @case ('assign') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M9 11l3 3L22 4"></path><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                    </svg>
                  }
                  @case ('backup') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    </svg>
                  }
                  @case ('group') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  }
                  @case ('site') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M3 21h18"></path><path d="M5 21V7l7-4 7 4v14"></path><path d="M10 21v-6h4v6"></path>
                    </svg>
                  }
                  @case ('settings') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                    </svg>
                  }
                  @case ('camera') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M23 7l-7 5 7 5V7z"></path><rect x="1" y="5" width="15" height="14" rx="2"></rect>
                    </svg>
                  }
                  @case ('bell') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                  }
                  @case ('dashboard') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="3" y="3" width="7" height="9" rx="1"></rect><rect x="14" y="3" width="7" height="5" rx="1"></rect><rect x="14" y="12" width="7" height="9" rx="1"></rect><rect x="3" y="16" width="7" height="5" rx="1"></rect>
                    </svg>
                  }
                  @case ('form') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path><path d="M16 13H8M16 17H8M10 9H8"></path>
                    </svg>
                  }
                  @case ('search') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path>
                    </svg>
                  }
                  @default {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                    </svg>
                  }
                }
              </span>
              <span class="sw-manual-nav-text">
                <span class="sw-manual-nav-label">{{ topic.title }}</span>
                <span class="sw-manual-nav-sub sw-text-2xs">{{ topic.tagline }}</span>
              </span>
            </button>

            @if (topic.children?.length && isExpanded(topic)) {
              <div class="sw-manual-nav-children">
                @for (child of topic.children; track child.id) {
                  <button
                    type="button"
                    class="sw-manual-nav-child"
                    [class.is-active]="child.id === activeTopic.id"
                    (click)="selectTopic(child)">
                    <span class="sw-manual-nav-child-label">{{ child.title }}</span>
                  </button>
                }
              </div>
            }
          }
        </div>
      }
    </nav>
  </aside>

  <div class="sw-manual-rail-scrim" [class.is-open]="railOpen" (click)="toggleRail()"></div>

  <main class="sw-manual-content" #contentPane>
    <button type="button" class="sw-manual-rail-toggle" (click)="toggleRail()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
      All topics
    </button>

    <header class="sw-manual-hero">
      <span class="sw-manual-crumb sw-text-2xs sw-tracking-wider">
        {{ activeGroupTitle }}
        @if (activeParent) {
          <span class="sw-manual-crumb-sep">/</span>{{ activeParent.title }}
        }
      </span>
      <h2 class="sw-manual-hero-title">{{ activeTopic.title }}</h2>
      <p class="sw-manual-hero-intro">{{ activeTopic.intro }}</p>
    </header>

    <ol class="sw-manual-steps">
      @for (step of activeTopic.steps; track step.title; let i = $index) {
        <li class="sw-manual-step">
          <span class="sw-manual-step-index">{{ i + 1 }}</span>
          <div class="sw-manual-step-body">
            <h3 class="sw-manual-step-title">{{ step.title }}</h3>
            <p class="sw-manual-step-text">{{ step.body }}</p>

            @if (step.bullets?.length) {
              <ul class="sw-manual-bullets">
                @for (bullet of step.bullets; track bullet) {
                  <li>{{ bullet }}</li>
                }
              </ul>
            }

            @if (step.image || step.video) {
              <div class="sw-manual-media">
              @if (step.image) {
                <figure class="sw-manual-shot">
                  <button type="button" class="sw-manual-shot-frame" title="Click to enlarge"
                    (click)="openLightbox(step.image)">
                    <img [src]="step.image.src" [alt]="step.image.alt || step.title" loading="lazy" />
                    <span class="sw-manual-shot-zoom" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path><path d="M11 8v6M8 11h6"></path>
                      </svg>
                    </span>
                  </button>
                  @if (step.image.caption) {
                    <figcaption class="sw-manual-shot-caption">{{ step.image.caption }}</figcaption>
                  }
                </figure>
              }

              @if (step.video) {
                <figure class="sw-manual-clip">
                  <div class="sw-manual-clip-frame">
                    <span class="sw-manual-clip-badge">
                      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M8 5v14l11-7z"></path>
                      </svg>
                      Clip
                    </span>
                    <video class="sw-manual-clip-player" controls controlsList="nodownload" preload="none"
                      playsinline [src]="step.video.src" [poster]="step.video.poster || null"></video>
                  </div>
                  @if (step.video.caption) {
                    <figcaption class="sw-manual-shot-caption">{{ step.video.caption }}</figcaption>
                  }
                </figure>
              }
              </div>
            }

            @if (step.link) {
              <button type="button" class="sw-manual-seemore" (click)="goToTopic(step.link.topicId)">
                {{ step.link.label || 'See more' }}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path>
                </svg>
              </button>
            }

            @if (step.callout) {
              <div class="sw-manual-callout" [class]="'sw-manual-callout--' + step.callout.kind">
                <span class="sw-manual-callout-label sw-text-2xs sw-tracking-wider">{{ step.callout.kind }}</span>
                <p>{{ step.callout.text }}</p>
              </div>
            }

          </div>
        </li>
      }
    </ol>

    @if (activeTopic.faqs?.length) {
      <section class="sw-manual-faq">
        <h3 class="sw-manual-section-title">Common questions</h3>
        @for (faq of activeTopic.faqs; track faq.q) {
          <details class="sw-manual-faq-item">
            <summary>{{ faq.q }}</summary>
            <p>{{ faq.a }}</p>
          </details>
        }
      </section>
    }

    <nav class="sw-manual-pager">
      @if (previousTopic) {
        <button type="button" class="sw-manual-pager-btn" [title]="previousTopic.title"
          [attr.aria-label]="'Previous topic: ' + previousTopic.title" (click)="selectTopic(previousTopic)">
          <svg class="sw-manual-pager-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="m15 18-6-6 6-6"></path>
          </svg>
          <span class="sw-manual-pager-label">Prev</span>
        </button>
      } @else {
        <span></span>
      }
      @if (nextTopic) {
        <button type="button" class="sw-manual-pager-btn sw-manual-pager-btn--next" [title]="nextTopic.title"
          [attr.aria-label]="'Next topic: ' + nextTopic.title" (click)="selectTopic(nextTopic)">
          <span class="sw-manual-pager-label">Next</span>
          <svg class="sw-manual-pager-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="m9 18 6-6-6-6"></path>
          </svg>
        </button>
      }
    </nav>
  </main>

</div>
</sw-drawer>

<!-- Outside <sw-drawer> on purpose: the drawer transforms itself to slide in, and a
     transformed ancestor makes position:fixed resolve against it instead of the
     viewport — which trapped this overlay inside the drawer. -->
@if (lightbox) {
  <div class="sw-manual-lightbox" role="dialog" aria-modal="true" (click)="closeLightbox()"
    (wheel)="onWheel($event)">
    <button type="button" class="sw-manual-lightbox-close" aria-label="Close image">&times;</button>

    <div class="sw-manual-lightbox-stage" [class.is-zoomed]="zoom > 1" [class.is-panning]="zoom > 1">
      <img
        [src]="lightbox.src"
        [alt]="lightbox.alt || ''"
        [style.transform]="imageTransform"
        draggable="false"
        (mousedown)="startPan($event)"
        (dblclick)="toggleZoom()"
        (click)="$event.stopPropagation()" />
    </div>

    @if (lightbox.caption) {
      <p class="sw-manual-lightbox-caption">{{ lightbox.caption }}</p>
    }

    <div class="sw-manual-zoombar" (click)="$event.stopPropagation()">
      <button type="button" [disabled]="zoom <= 1" aria-label="Zoom out" (click)="zoomOut()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"></path></svg>
      </button>
      <button type="button" class="sw-manual-zoombar-level" (click)="resetZoom()"
        title="Reset to fit">{{ zoomPercent }}%</button>
      <button type="button" [disabled]="zoom >= 4" aria-label="Zoom in" (click)="zoomIn()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14"></path><path d="M5 12h14"></path></svg>
      </button>
    </div>
  </div>
}

